module.exports = __webpack_public_path__ + "static/img/qnbg2.37f064b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qnbg2.png
// module id = 75
// module chunks = 0